var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',{attrs:{"to":{ name: 'tour', params: { tourId: _vm.tour.id } }}},[_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(" "+_vm._s(_vm.tour.name)+" - "+_vm._s(_vm.countSheet)+" ")]),_c('v-list-item-subtitle',[_vm._v(" "+_vm._s(_vm.technician ? _vm.technician.full_name : "-")+" ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }